export default __webpack_public_path__ + "media/zurb/img/b2b_ecommerce/lin_desktop-dd87c447a7692532eb8525fec280e011.png";